import localStore from "@/global/store/local-store";
import { request } from "@/global/config/request";
import { AxiosResponse } from "axios";
import qs from "qs";


export function createPrimitive(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return request.post(`/primitives`, data, {
        params: {
            ...params,
            projectUuid: localStore.projectId
        }
    })
}

export function createPrimitiveMulti(data: any, params?: {}): Promise<AxiosResponse<any>> {
    return request.post(`/primitives/multi`, data, {
        params: {
            ...params,
            projectUuid: localStore.projectId
        }
    })
}

export function findPrimitivesInGraphic(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/projects/${projectUuid}/primitives`, {
        params: {
            ...params,
        }
    })
}
export function findPrimitivesInGraphicByTypes(projectUuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/projects/${projectUuid}/primitives/types`, {
        params: {
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function findPrimitivesByUuid(uuid: string, params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/primitives/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function deletePrimitivesInGraphic(uuids: string[], params?: {}): Promise<AxiosResponse<any>> {
    return request.post(`/primitives/delete`, uuids, {
        params: {
            ...params,
            projectUuid: localStore.projectId
        }
    })
}